import React from "react";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from '@material-ui/core/FormControlLabel';


const SwitchComponent = (props) => {
  return (
      <FormControlLabel
          control={<Switch
              size={props.size}
              color={props.color}
              checked={props.checked}
              onChange={(e) => props.updateValue(e.target.checked)}
              name="switch"
              inputProps={{ "aria-label": "secondary checkbox" }}
          />}
          label={props.label}
      />

  );
};

export default SwitchComponent;
